
import { defineComponent } from 'vue';
import FbxButton from '@/components/fbx-button.vue';
import ReturnOptions from '@/components/ReturnOptions.vue';
import { mapGetters } from 'vuex';
import { WorkflowTypes } from '@/types/WorkflowTypes';

export default defineComponent({
    components: {
        FbxButton,
        ReturnOptions,
    },
    props: {
        wasNonDamageIssue: String,
    },
    computed: {
        ...mapGetters({
            workflowOrigin: 'getWorkflowOrigin',
        }),
        showNonDamageIssue(): boolean {
            return this.wasNonDamageIssue === 'true';
        },
    },
    methods: {
        findAnotherTrailer() {
            if (this.workflowOrigin === WorkflowTypes.selectATrailer) {
                this.$router.push({ name: 'SelectTrailer' });
            } else if (this.workflowOrigin === WorkflowTypes.findATrailer) {
                this.$router.push({ name: 'FindTrailer' });
            } else if (this.workflowOrigin === WorkflowTypes.virtualRedTag) {
                this.$router.push({ name: 'VirtualRedTagEntry' });
            } else {
                this.$router.push({ name: 'DriverLanding' });
            }
        },
    },
});
